/**
 * checks if the argument is a string or not
 * @param {any} str - immutable list
 * @returns {string|null} returns string or null
*/
const stringOrNull = str => str.length ? str : null // eslint-disable-line
export default stringOrNull

